export enum PriceSortDirection {
  LowToHigh,
  HighToLow
}

export class PriceSort {
  sortDirection: PriceSortDirection = PriceSortDirection.LowToHigh;

  constructor(sortDirection: PriceSortDirection) {
    this.sortDirection = sortDirection;
  }
}
